import React from 'react';
import './styles/index.css';
import Login from './components/Login';
import Sidebar from './components/Sidebar';
import ChatArea from './components/ChatArea';
import MobileMenu from './components/MobileMenu';
import LandingPage from './components/LandingPage';
import About from './components/About';
import { ChatProvider, useChat } from './context/ChatContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation
} from 'react-router-dom';

function ChatRoutes() {
  const {
    token,
    tokenValidating,
    handleLogin,
    handleLogout,
    sidebarOpen,
    chats,
    currentChatId,
    handleNewChat,
    handleSelectChat,
    handleDeleteChat,
    handleRenameChat,
    toggleSidebar,
    closeSidebar,
    loading,
    isStreaming,
    messages,
    handleSendMessage,
    handleHeroSendMessage,
    currentBotId,
    handleSwitchBot,
    screens,
    screen,
    authError
  } = useChat();
  const navigate = useNavigate();
  const location = useLocation();

  // Show loading spinner while token is being validated
  if (tokenValidating) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <div className="loading-text">Loading...</div>
      </div>
    );
  }

  // Only show login modal and blur on /chat route if not logged in
  const isChatRoute = location.pathname === '/chat';
  const showLoginModal = isChatRoute && !token && !tokenValidating;
  const blurStyle = showLoginModal ? { filter: 'blur(6px)', pointerEvents: 'none', userSelect: 'none' } : {};

  return (
    <>
      <div style={blurStyle}>
        <Routes>
          <Route path="/" element={<LandingPage messages={messages}
                    loading={loading}
                    isStreaming={isStreaming}
                    onSendMessage={handleHeroSendMessage}
                    currentBotId={currentBotId}
                    currentScreenId={screen}
                    onSwitchBot={handleSwitchBot}
                    screens={screens} 
                    onNavigateToLogin={() => {}} />} />
          <Route path="/about" element={<About />} />
          <Route path="/chat" element={
            token ? (
              <div className="chatgpt-app">
                <MobileMenu onToggleSidebar={toggleSidebar} />
                <Sidebar
                  chats={chats}
                  currentChatId={currentChatId}
                  onSelectChat={handleSelectChat}
                  onNewChat={handleNewChat}
                  onDeleteChat={handleDeleteChat}
                  onRenameChat={handleRenameChat}
                  onLogout={() => {
                    handleLogout();
                    navigate('/', { replace: true });
                  }}
                  isSidebarOpen={sidebarOpen}
                  onCloseSidebar={closeSidebar}
                  toggleSidebar={toggleSidebar}
                />
                <main className="chat-area">
                  <ChatArea
                    messages={messages}
                    loading={loading}
                    isStreaming={isStreaming}
                    onSendMessage={handleSendMessage}
                    currentBotId={currentBotId}
                    currentScreenId={screen}
                    onSwitchBot={handleSwitchBot}
                    screens={screens}
                  />
                </main>
              </div>
            ) : (
              // If not logged in, still render the chat area (blurred), and show modal
              <div className="chatgpt-app">
                <MobileMenu onToggleSidebar={toggleSidebar} />
                <Sidebar
                  chats={chats}
                  currentChatId={currentChatId}
                  onSelectChat={handleSelectChat}
                  onNewChat={handleNewChat}
                  onDeleteChat={handleDeleteChat}
                  onRenameChat={handleRenameChat}
                  onLogout={() => {
                    handleLogout();
                    navigate('/', { replace: true });
                  }}
                  isSidebarOpen={sidebarOpen}
                  onCloseSidebar={closeSidebar}
                  toggleSidebar={toggleSidebar}
                />
                <main className="chat-area">
                  <ChatArea
                    messages={messages}
                    loading={loading}
                    isStreaming={isStreaming}
                    onSendMessage={handleSendMessage}
                    currentBotId={currentBotId}
                    currentScreenId={screen}
                    onSwitchBot={handleSwitchBot}
                    screens={screens}
                  />
                </main>
              </div>
            )
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      {showLoginModal && (
        <Login 
          onLogin={token => {
            handleLogin(token);
            // Optionally, redirect to /chat if needed
            // No need to navigate, already on /chat
          }} 
          error={authError}
        />
      )}
    </>
  );
}

function App() {
  return (
    <ChatProvider>
      <Router>
        <ChatRoutes />
      </Router>
    </ChatProvider>
  );
}

export default App;
